import { render, staticRenderFns } from "./game-link.vue?vue&type=template&id=33bed6fe&scoped=true"
import script from "./game-link.vue?vue&type=script&lang=js"
export * from "./game-link.vue?vue&type=script&lang=js"
import style0 from "./game-link.vue?vue&type=style&index=0&id=33bed6fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bed6fe",
  null
  
)

export default component.exports